const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");

const styles = require("./styles/StudentRegistration.css");

module.exports = createReactClass({
	displayName: "StepWrapper",

	propTypes: {
		copy: PT.object.isRequired,
		children: PT.node.isRequired,
		renderButton: PT.func.isRequired,
		renderError: PT.func.isRequired,
		handleSubmit: PT.func.isRequired,
		handleBack: PT.func,
		stepNumber: PT.number.isRequired,
		totalNumSteps: PT.number.isRequired,
	},

	render: function() {
		const {
			stepNumber,
			totalNumSteps,
			copy,
			children,
			renderButton,
			renderError,
			handleSubmit,
			handleBack,
		} = this.props;
		return (
			<div className={styles.main}>
				<div className={styles.step}>
					<div className={styles.stepTitle}>
						{`Step ${stepNumber} of ${totalNumSteps}: ${copy.description}`}
					</div>
					<div className={styles.stepContents}>{children}</div>
				</div>
				{renderError()}
				<div className={styles.buttonContainer}>
					{handleBack && renderButton("Back", handleBack, styles.buttonAlt)}
					{renderButton("Continue", handleSubmit)}
				</div>
				{copy.below}
			</div>
		);
	},
});
